import { IProduct } from "redux/reducers/models/product";

export type BrowseFilterType = "all" | "uncategorized" | "department" | "category" | "subcategory";

export interface IBrowseFilter {
  type: BrowseFilterType;
  id?: number;
}

export const defaultBrowseFilter: IBrowseFilter = { type: "all" };

export const PRODUCT_SEARCH_PAGE_SIZE = 50;

export function parseProductSearchResponse(data: unknown): { products: IProduct[]; totalCount: number } {
  if (data && typeof data === "object" && !Array.isArray(data) && "product" in data) {
    const countedData = data as { product?: IProduct[]; count?: number };
    const products = countedData.product ?? [];
    return { products, totalCount: countedData.count ?? products.length };
  }

  const products = Array.isArray(data) ? (data as IProduct[]) : [];
  return { products, totalCount: products.length };
}

export function productMatchesBrowseFilter(product: IProduct, browseFilter: IBrowseFilter) {
  if (browseFilter.type === "all") {
    return true;
  }

  if (browseFilter.type === "uncategorized") {
    return product.department_id == null && product.department == null;
  }

  if (browseFilter.type === "department" && browseFilter.id != null) {
    return product.department_id === browseFilter.id || product.department?.id === browseFilter.id;
  }

  if (browseFilter.type === "category" && browseFilter.id != null) {
    return product.category_id === browseFilter.id || product.category?.id === browseFilter.id;
  }

  if (browseFilter.type === "subcategory" && browseFilter.id != null) {
    return product.subcategory_id === browseFilter.id || product.subcategory?.id === browseFilter.id;
  }

  return false;
}

export function countFolderProductsMatchingFilter(folderProducts: IProduct[], browseFilter: IBrowseFilter) {
  return folderProducts.filter(product => productMatchesBrowseFilter(product, browseFilter)).length;
}

export function buildBrowseFilters(browseFilter: IBrowseFilter) {
  if (browseFilter.type === "all") {
    return undefined;
  }

  if (browseFilter.type === "uncategorized") {
    return [{ label: "uncategorized" as const, value: [1] }];
  }

  if (browseFilter.type === "department" && browseFilter.id != null) {
    return [{ label: "department_id" as const, value: [browseFilter.id] }];
  }

  if (browseFilter.type === "category" && browseFilter.id != null) {
    return [{ label: "category_id" as const, value: [browseFilter.id] }];
  }

  if (browseFilter.type === "subcategory" && browseFilter.id != null) {
    return [{ label: "subcategory_id" as const, value: [browseFilter.id] }];
  }

  return undefined;
}
